import React from "react";
import MemberLoginComponent from "../Component/MemberLoginComponent/MemberLoginComponent";

function MemberLoginPage(props) {
  return (
    <>
      <MemberLoginComponent />
    </>
  );
}

export default MemberLoginPage;
